import * as React from 'react'
import type { IApplicationDefinition } from '@apps-config/app-definition'
import type { History } from 'history'
import { Application as StoreIntApplication } from '@applications/self-service-store'
import {
  storeIntReducer,
  StoreIntAction,
} from '@telstra-connect/self-service-store/reducers'
import { loadFeatureFlags } from '@telstra-connect/self-service-store/feature-flags/load-flags'
import { platformAppName } from '@telstra-connect/utils/data/platform-data'
import { ApplicationName as StoreIntAppName } from '@telstra-connect/self-service-store/activity-tracking'
import type { IFeatureFlags as IDashboardFlags } from '@telstra-connect/dashboard/feature-flags/common'
import type { IStoreIntState } from '@telstra-connect/self-service-store/state'
import type { IFeatureFlags as StoreIntFlags, OrderExpressFlags } from '@telstra-connect/self-service-store/feature-flags/common'
import { setFeatureFlags } from '@apps-config/feature-flags'
import '../node_modules/telstra-ui/resources/telstraui.css'
import '../node_modules/telstra-ui/resources/themes/pacific.css'
import { getStoreIntFlags } from '@telstra-connect/self-service-store/feature-flags'
import { LoggerSetUp } from '@utils'
import { isFlagOn } from '@telstra-connect/feature-flags'


LoggerSetUp.enableLogging();

loadFeatureFlags();

export function getRedesignTilesPhase2() {
  const flags = getStoreIntFlags()
  // tslint:disable-next-line: no-string-literal
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }

  if (isFlagOn(flags.storeInt)) {
    return true
  }

  return false
}

export interface IGlobalMapProps {
  width?: number | string
  height?: number | string
  className?: string
}

function getStoreIntApplication() {
  setFeatureFlags()
  return StoreIntApplication
}

function getStoreIntReducer() {
  return storeIntReducer
}

type TGetSessionDetails = () => { sessionId: string }

interface IApplications {
  [platformAppName]?: IDashboardFlags
  [StoreIntAppName]?: StoreIntFlags
  ['Order Express']?: OrderExpressFlags
  ['Billing']?: object
}


declare const global: {
  TCONN: {
    getAppRoutingHistory: () => History
    getSessionDetails: TGetSessionDetails
    Platform: {
      isSecureAuth: boolean,
      resolveTargetURL: (targetURL: string) => string
    },
    StoreInt: {
      GetApplication: () => IApplicationDefinition
      GetReducers: () => (state: IStoreIntState, action: StoreIntAction) => IStoreIntState
    }
  }
  applications: IApplications
}

global.TCONN = { ...global.TCONN }

global.TCONN.StoreInt = {
  GetApplication: getStoreIntApplication,
  GetReducers: getStoreIntReducer,
}

export default global
